const config = {
  db_path: "geoeco",
};

export default config;
